import ConsoleIcon from "../../../public/assets/svg/ConsoleIcon";
import LearnIcon from "../../../public/assets/svg/LearnIcon";
import StoreIcon from "../../../public/assets/svg/StoreIcon";
import { LC_BASE_URL, STORE_BASE_URL } from "../../config/envConstants";
import { jsx } from "@emotion/react";
import DocsIcon from "../../../public/assets/svg/DocsIcon";
import EventsIcon from "../../../public/assets/svg/EventsIcon";
import ForumsIcon from "../../../public/assets/svg/ForumsIcon";
import WebinarIcon from "../../../public/assets/svg/WebinarIcon";
import HomeIcon from "../../../public/assets/svg/HomeIcon";
import ProfileIcon from "../../../public/assets/svg/ProfileIcon";
import SettingsIcon from "../../../public/assets/svg/SettingsIcon";
import HelpSupportIcon from "../../../public/assets/svg/HelpSupportIcon";
import LogoutIcon from "../../../public/assets/svg/LogoutIcon";
import EditIcon from "../../../public/assets/svg/EditIcon";
import KeyIcon from "../../../public/assets/svg/KeyIcon";
import AccountSettingsSvg from "../../../public/assets/svg/AccountSettingsIcon";

export const deviceNavbarData = [
  {
    id: 0,
    title: "mecha",
    link: "/",
    linkTextColor: undefined,
    logo: "MechaLogo",
    iconPosition: "left",
    navigationComponents: [
      {
        __component: "navigation.dropdown",
        id: 0,
        list: [
          {
            id: 0,
            title: "Platform",
            link: "#",
          },
          {
            id: 1,
            title: "Hardware",
            link: "#",
          },
          {
            id: 2,
            title: "Solutions",
            link: "#",
          },
          {
            id: 3,
            title: "Store",
            link: STORE_BASE_URL,
          },
          {
            id: 4,
            title: "App Center",
            link: "/",
          },
          {
            id: 5,
            title: "Resources",
            link: "#",
            navigationComponents: [
              {
                __component: "navigation.dropdown",
                id: 0,
                list: [
                  {
                    id: 0,
                    title: "Learning center",
                    link: LC_BASE_URL + "/learn",
                    icon: jsx(LearnIcon),
                    iconPosition: "left",
                    tagLine: "Get to know more about Mecha",
                  },
                  {
                    id: 1,
                    title: "Forums",
                    link: "#",
                    icon: jsx(ForumsIcon),
                    iconPosition: "left",
                    tagLine: "Ask questions, build your community",
                  },
                  {
                    id: 2,
                    title: "Docs",
                    link: "#",
                    icon: jsx(DocsIcon),
                    iconPosition: "left",
                    tagLine: "Readable material on Mecha",
                  },
                  {
                    id: 3,
                    title: "Beta Program",
                    link: STORE_BASE_URL,
                    icon: jsx(StoreIcon),
                    iconPosition: "left",
                    tagLine: "Buy Mecha compute",
                  },
                  {
                    id: 4,
                    title: "Webinars",
                    link: "#",
                    icon: jsx(WebinarIcon),
                    iconPosition: "left",
                    tagLine: "Buy Mecha compute",
                  },
                  {
                    id: 5,
                    title: "Events",
                    link: LC_BASE_URL + "/events",
                    icon: jsx(EventsIcon),
                    iconPosition: "left",
                    tagLine: "Buy Mecha compute",
                  },
                  {
                    id: 6,
                    title: "Go to mecha.so",
                    link: "/",
                    icon: jsx(HomeIcon),
                    iconPosition: "left",
                    tagLine: "",
                  },
                ],
              },
            ],
          },
          {
            id: 6,
            title: "Blog",
            link: "#",
          },
        ],
      },
      {
        __component: "navigation.predefined",
        id: 1,
        list: ["github", "console_login"],
      },
    ],
  },
];

export const deviceLoggedInNavbarData = [
  {
    id: 0,
    title: "Console",
    link: "/",
    linkTextColor: "",
    logo: "MechaIcon",
    icon: jsx(ConsoleIcon),
    iconPosition: "left",
    navigationComponents: [
      {
        __component: "navigation.dropdown",
        id: 0,
        list: [
          {
            id: 0,
            title: "Devices",
            link: "/devices",
          },
          {
            id: 1,
            title: "Automation",
            link: "/automation",
          },
          // {
          //   id: 1,
          //   title: "Apps",
          //   link: "/apps",
          // },
          // {
          //   id: 2,
          //   title: "App Center",
          //   link: "/app-center",
          //   icon: jsx(UrlIcon, {
          //     className:
          //       "w-[10px] h-[10px] cursor-pointer flex items-end text-primary-500",
          //   }),
          //   iconPosition: "right",
          // },
          // {
          //   id: 2,
          //   title: "Docs",
          //   link: "docs",
          // },
          // {
          //   id: 3,
          //   title: "Community",
          //   link: "community",
          // },
          {
            id: 3,
            title: "Resources",
            link: "resources",
            navigationComponents: [
              {
                __component: "navigation.dropdown",
                id: 0,
                list: [
                  {
                    id: 0,
                    title: "Learning center",
                    link: LC_BASE_URL + "/learn",
                    icon: jsx(LearnIcon),
                    iconPosition: "left",
                    tagLine: "Get to know more about Mecha",
                  },
                  {
                    id: 1,
                    title: "Forums",
                    link: "#",
                    icon: jsx(ForumsIcon),
                    iconPosition: "left",
                    tagLine: "Ask questions, build your community",
                  },
                  {
                    id: 2,
                    title: "Docs",
                    link: "#",
                    icon: jsx(DocsIcon),
                    iconPosition: "left",
                    tagLine: "Readable material on Mecha",
                  },
                  {
                    id: 3,
                    title: "Beta Program",
                    link: STORE_BASE_URL,
                    icon: jsx(StoreIcon),
                    iconPosition: "left",
                    tagLine: "Buy Mecha compute",
                  },
                  {
                    id: 4,
                    title: "Webinars",
                    link: "#",
                    icon: jsx(WebinarIcon),
                    iconPosition: "left",
                    tagLine: "Buy Mecha compute",
                  },
                  {
                    id: 5,
                    title: "Events",
                    link: LC_BASE_URL + "/events",
                    icon: jsx(EventsIcon),
                    iconPosition: "left",
                    tagLine: "Buy Mecha compute",
                  },
                  {
                    id: 6,
                    title: "Go to mecha.so",
                    link: "/",
                    icon: jsx(HomeIcon),
                    iconPosition: "left",
                    tagLine: "",
                  },
                ],
              },
            ],
          },
          // {
          //   id: 4,
          //   title: "Settings",
          //   link: "/settings",
          // },
        ],
      },
      {
        __component: "navigation.predefined",
        id: 1,
        // list: ["search", "notification", "user_profile"],
        list: ["user_profile"],
      },
    ],
  },
];

export const notificationData = [
  { id: 0, title: "Notification 1", link: "#" },
  { id: 1, title: "Notification 2", link: "#" },
  { id: 2, title: "Notification 3", link: "#" },
  { id: 3, title: "Notification 4", link: "#" },
  { id: 4, title: "Notification 5", link: "#" },
  { id: 5, title: "Notification 6", link: "#" },
];

export const profileData = [
  [
    { id: 0, title: "My Profile", link: "/settings/my-profile" },
    // { id: 1, title: "Edit my Profile", link: "/settings/my-profile" },
    { id: 1, title: "My Account", link: "/settings/my-account" },
    { id: 2, title: "API Keys", link: "/settings/api-keys" },
  ],
  [{ id: 3, title: "Sign out", link: "/auth/signin" }],
];

export const mobileProfileData = [
  [
    {
      id: 0,
      title: "View my Profile",
      link: "/profile",
      icon: jsx(ProfileIcon, { className: "w-4 h-4" }),
    },
    {
      id: 1,
      title: "Edit my Profile",
      link: "/settings/my-profile",
      icon: jsx(EditIcon, { className: "w-4 h-4" }),
    },
    {
      id: 2,
      title: "My Account",
      link: "/settings/my-account",
      icon: jsx(AccountSettingsSvg, { className: "w-5 h-5" }),
    },
  ],
  [
    {
      id: 3,
      title: "Settings",
      link: "/settings/my-profile",
      icon: jsx(SettingsIcon, { className: "w-5 h-5" }),
    },
    {
      id: 4,
      title: "Help",
      link: "/help-&-support",
      icon: jsx(HelpSupportIcon, { className: "w-5 h-5" }),
    },
  ],
  [
    {
      id: 5,
      title: "Sign out",
      link: "/auth/signin",
      icon: jsx(LogoutIcon, { className: "w-4 h-4" }),
    },
  ],
];

export const navigationListErrorPage = [
  {
    id: 0,
    title: "",
    link: "/",
    heroLink: false,
    logo: "MechaLogo",
    navigationComponents: [
      {
        __component: "navigation.predefined",
        id: 1,
        list: ["search"],
      },
    ],
  },
];

export const settingNavList = [
  {
    name: "My Profile",
    slug: "my-profile",
    icon: jsx(ProfileIcon, {
      className: "w-5 h-5 mr-1.5",
    }),
  },
  {
    name: "My Account",
    slug: "my-account",
    icon: jsx(SettingsIcon, {
      className: "w-5 h-5 mr-1.5",
      strokeWidth: 3,
    }),
  },
  {
    name: "API Keys",
    slug: "api-keys",
    icon: jsx(KeyIcon, {
      className: "w-5 h-5 mr-1.5",
      strokeWidth: 3,
    }),
  },
  // {
  //   name: "Connections",
  //   slug: "connections",
  //   icon: jsx(ConnectionIcon, {
  //     className: "w-5 h-5 mr-1.5",
  //     strokeWidth: 3,
  //   }),
  // },
  // {
  //   name: "Themes",
  //   slug: "themes",
  //   icon: jsx(ThemeIcon, {
  //     className: "w-5 h-5 mr-1.5",
  //     strokeWidth: 3,
  //   }),
  // },
  // {
  //   name: "Appearance",
  //   slug: "appearance",
  //   icon: jsx(AppearanceIcon, {
  //     className: "w-5 h-5 mr-1.5",
  //     strokeWidth: 3,
  //   }),
  // },
  // {
  //   name: "Help & Support",
  //   slug: "help-&-support",
  //   icon: jsx(HelpSupportIcon, {
  //     className: "w-5 h-5 mr-1.5",
  //     strokeWidth: 3,
  //   }),
  // },
];
